import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const monitoredItems = [
    ['Website', 'Updates and security'],
    ['Email', 'Delivery and authentication'],
    ['Hosting', 'Backups and performance'],
    ['Domains', 'DNS, SSL and renewals']
  ];

  return (
    <section className="relative overflow-hidden bg-[#174C3C] pt-12 pb-12 text-white lg:pt-20 lg:pb-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-[1.1fr_.9fr]">
          <div className="max-w-3xl">
            <h1 className="text-5xl leading-[1.03] text-white sm:text-6xl lg:text-7xl">
              Stop Worrying About Your Website. We&apos;ll{' '}
              <span className="text-[#D7B77A]">Take Care of It.</span>
            </h1>
            <p className="mt-9 max-w-2xl text-xl leading-relaxed text-white/75 sm:text-2xl">
              For small businesses that want the website, email, and hosting
              looked after — and a real person when something breaks. You
              talk to Dave. A support team does the day-to-day work.
            </p>

            <div className="mt-11">
              <Link
                to="/digital-review"
                className="home-button-on-dark bg-white"
              >
                Request a Digital Review
              </Link>
              <p className="mt-8 text-base text-white/60">
                <Link
                  to="/get-started"
                  className="font-bold text-white underline decoration-2 underline-offset-4"
                >
                  Get started
                </Link>
                <span className="mx-3 text-white/35">·</span>
                <Link
                  to="/agency-services"
                  className="font-bold text-[#D7B77A] underline decoration-2 underline-offset-4"
                >
                  Agency white-label
                </Link>
              </p>
            </div>
          </div>

          <div className="home-paper relative border border-[#3B7C6D]/20 p-7 sm:p-10">
            <div className="absolute -right-3 -top-3 h-8 w-8 border-r-2 border-t-2 border-[#D7B77A]" />
            <div className="mb-8 flex items-start justify-between border-b border-[#17211E]/15 pb-6">
              <div>
                <div className="text-xs font-bold uppercase tracking-[0.22em] text-[#174C3C]">
                  Monthly care note
                </div>
                <div className="mt-2 home-serif text-2xl text-[#17211E]">
                  What we keep an eye on
                </div>
              </div>
              <div className="text-right text-xs font-bold uppercase tracking-wider text-[#17211E]/45">
                ManagedSite<br />Operations
              </div>
            </div>

            <div className="space-y-5">
              {monitoredItems.map(([name, detail]) => (
                <div key={name}>
                  <div className="flex items-center justify-between gap-4">
                    <span className="font-bold text-[#17211E]">{name}</span>
                    <span className="text-sm font-semibold text-[#174C3C]">
                      Reviewed
                    </span>
                  </div>
                  <div className="mt-3 home-report-line" />
                  <p className="mt-2 text-sm text-[#17211E]/65">{detail}</p>
                </div>
              ))}
            </div>

            <div className="mt-9 border-t border-[#17211E]/15 pt-5 text-sm italic text-[#17211E]/60">
              Clear notes. Fewer surprises. Someone responsible for the details.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;